import './UsersPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import A from 'components/A';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import H3 from 'components/H3';
import Icon from 'components/Icon';
import ModalFileUpload from 'components/ModalFileUpload';
import FormValidationMessage from 'components/FormValidationMessage';

export default class UserImportModal extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func.isRequired,
        error: PropTypes.object,
        fileToUpload: PropTypes.object,
        handleFileSelectedToUpload: PropTypes.func.isRequired,
        show: PropTypes.bool,
        showCloseButton: PropTypes.bool
    };

    constructor() {
        super();

        this.state = {
            showInstructions: false
        }
    }

    closeModal() {
        this.props.closeModal();
        this.openCloseInstructions();
    }

    generatePreviewHtml() {
        return (
            <div className="modal__dropzone-preview">
                <Icon icon="document"/>
                <strong>Upload: </strong>{this.props.fileToUpload.name}
            </div>
        )
    }

    openCloseInstructions() {
        let instructionsEl = document.querySelector('.user-import__instructions');

        if(this.state.showInstructions === false) {
            instructionsEl.style.height = document.querySelector('.user-import__instructions--inner').offsetHeight + 'px'
        } else {
            instructionsEl.style.height = 0;
        }

        this.setState({showInstructions: !this.state.showInstructions});
    }

    render() {
        let { error, fileToUpload, handleFileSelectedToUpload } = this.props;

        return (
            <Modal show={this.props.show}
                   className="user-import-modal user-modal"
                   handleClose={this.closeModal.bind(this)}
                   width="full">
                <header className="user-modal__header">
                    <H3 className="modal__title">
                        Bulk User Import
                    </H3>
                    <Form className="modal-form">
                        <FormRow>
                            <ModalFileUpload fileToUpload={fileToUpload}
                                             generatePreview={this.generatePreviewHtml.bind(this)}
                                             handleFileDrop={handleFileSelectedToUpload.bind(this)}
                                             hasFile={false}
                                             instructionsText="Drag CSV file here or click to upload." />
                        </FormRow>

                        <FormRow>
                            <A href="/templates/pinpoint-user-import-template.csv" target="_blank">Download CSV Template</A>
                            <div className={classNames('user-import__instructions-button', {'open': this.state.showInstructions === true})}
                                 onClick={this.openCloseInstructions.bind(this)}
                                 role="button">
                                CSV File Instructions
                            </div>
                            <div className={classNames('user-import__instructions', {'open': this.state.showInstructions === true})}>
                                <div className="user-import__instructions--inner">
                                    <div className="user-import__instructions-text">
                                        The CSV must have five columns in this order: user’s “e-mail”, “First Name”, “Last Name”, “Phone”, and the user’s “Role”. Valid roles are: “Administrator”, “Inbox, Create &amp; Library”, “Inbox &amp; Create”, “Inbox &amp; Library”, and “Inbox”.
                                    </div>

                                    <img src="/img/user-import-example.jpg" alt="User import example" />
                                </div>
                            </div>
                        </FormRow>

                        {error != null && Object.keys(error).length > 0 ? (
                            <FormRow>
                                <FormValidationMessage>
                                    {error.friendlyMessage || error.message}
                                </FormValidationMessage>
                            </FormRow>
                        ) : null}

                        {this.props.showCloseButton === true ? (
                            <FormRow>
                                Users successfully imported. <span role="button" className="close-modal-link" onClick={this.props.closeModal.bind(this)}>Close this window</span>.
                            </FormRow>
                        ) : null}
                    </Form>
                </header>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/UserImportModal.js